import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-mt-6 tw-flex" };
const _hoisted_2 = { class: "tw-px-4 md:tw-px-6 tw-mx-auto tw-max-w-screen-2xl sm:tw-w-[calc(100%-280px)] tw-w-full lg:tw-pt-0 tw-pt-3 sm:tw-mt-0 tw-mt-5" };
const _hoisted_3 = {
    key: 0,
    class: "tw-relative tw-w-[70%] tw-h-[calc(100vh-180px)] tw-mt-6 md:tw-block tw-hidden",
    id: "iframe-container"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 1,
    class: "tw-flex tw-items-center tw-justify-center tw-w-[70%] tw-h-[calc(100vh-180px)] tw-bg-opacity-75 tw-bg-black tw-mt-6 tw-flex-col"
};
const _hoisted_6 = { class: "tw-px-6 tw-py-4 tw-bg-white tw-rounded-lg tw-shadow-lg tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center" };
const _hoisted_7 = { class: "tw-relative tw-w-[95%] tw-h-[60vh] tw-mx-auto" };
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 3,
    class: "tw-fixed tw-mt-18 tw-inset-0 tw-bg-black tw-bg-opacity-75 tw-z-50 tw-flex tw-items-center tw-justify-center md:tw-hidden"
};
const _hoisted_10 = { class: "tw-relative tw-w-[95%] tw-h-auto tw-mx-auto" };
const _hoisted_11 = { class: "tw-px-6 tw-py-4 tw-bg-white tw-rounded-lg tw-shadow-lg tw-text-center" };
const _hoisted_12 = {
    key: 1,
    ref: "scrollContainer",
    class: "tw-max-h-[calc(100vh-180px)] tw-overflow-auto"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = { class: "tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-60 tw-opacity-0 hover:tw-opacity-100 tw-transition-opacity tw-duration-300 tw-flex tw-items-center tw-justify-center tw-flex-col tw-rounded-xl" };
const _hoisted_16 = { class: "tw-text-white tw-text-sm tw-font-bold tw-text-center" };
const _hoisted_17 = { class: "tw-text-white tw-text-[12px]" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CasinoLiveComponentSidebar = _resolveComponent("CasinoLiveComponentSidebar");
    const _component_CasinoLiveHeader = _resolveComponent("CasinoLiveHeader");
    const _component_CardTitle = _resolveComponent("CardTitle");
    const _component_CardContent = _resolveComponent("CardContent");
    const _component_Card = _resolveComponent("Card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CasinoLiveComponentSidebar, {
            liveGameCategories: $props.liveGameCategories,
            selectedCategory: $props.selectedLiveCategory,
            onCategoryChanged: $setup.closeGame
        }, null, 8, ["liveGameCategories", "selectedCategory", "onCategoryChanged"]),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CasinoLiveHeader, {
                games: $props.games,
                isLoading: $props.isLoading
            }, null, 8, ["games", "isLoading"]),
            _createElementVNode("div", {
                class: _normalizeClass($setup.gameUrl || ($setup.showMessage && !$setup.isMobile)
                    ? 'tw-flex tw-w-full tw-gap-4'
                    : 'tw-w-full')
            }, [
                ($setup.gameUrl && !$setup.showMessage && !$setup.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("button", {
                            class: "tw-absolute tw-top-2 tw-right-2 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => ($setup.closeGame && $setup.closeGame(...args)))
                        }, " Close "),
                        _createElementVNode("iframe", {
                            src: $setup.gameUrl,
                            frameborder: "0",
                            class: "tw-w-full tw-h-full"
                        }, null, 8, _hoisted_4)
                    ]))
                    : ($setup.showMessage && !$setup.isMobile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "tw-text-lg tw-font-semibold tw-text-red-500" }, " Due to a technical glitch, the game could not be loaded. Please try again. ", -1)),
                                _createElementVNode("button", {
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => ($setup.closeGame && $setup.closeGame(...args))),
                                    class: "tw-bg-red-500 tw-text-white tw-rounded-full tw-px-4 tw-py-2 tw-mt-4"
                                }, " Close ")
                            ])
                        ]))
                        : ($setup.gameUrl && !$setup.showMessage && $setup.isMobile)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "tw-fixed tw-mt-18 tw-inset-0 tw-bg-black tw-bg-opacity-75 tw-z-50 tw-flex tw-items-center tw-justify-center md:tw-hidden",
                                id: "iframe-container",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeGame && $setup.closeGame(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                        class: "tw-absolute tw-top-8 tw-right-0 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                                        onClick: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => ($setup.closeGame && $setup.closeGame(...args)))
                                    }, " Close "),
                                    _createElementVNode("iframe", {
                                        src: $setup.gameUrl,
                                        frameborder: "0",
                                        class: "tw-w-full tw-h-full tw-rounded-lg"
                                    }, null, 8, _hoisted_8)
                                ])
                            ]))
                            : ($setup.showMessage && $setup.isMobile)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "tw-text-xl tw-font-semibold tw-text-red-500" }, " Due to a technical glitch, the game could not be loaded. Please try again. ", -1)),
                                            _createElementVNode("button", {
                                                onClick: _cache[4] || (_cache[4] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeGame && $setup.closeGame(...args))),
                                                class: "tw-bg-red-500 tw-text-white tw-rounded-full tw-px-4 tw-py-2 tw-mt-4"
                                            }, " Close ")
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass($setup.gameUrl || ($setup.showMessage && !$setup.isMobile)
                        ? 'tw-w-full md:tw-w-[30%]'
                        : 'tw-w-full')
                }, [
                    _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-col-span-full tw-xl:col-span-4 tw-w-full tw-bg-transparent" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_CardTitle, { class: "tw-mb-4 tw-text-lg" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.selectedLiveCategory?.name || 'All'), 1)
                                ]),
                                _: 1
                            }),
                            ($props.isLoading && $props.games.length === 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    ($props.isLoading)
                                        ? (_openBlock(), _createBlock(_component_CardContent, {
                                            key: 0,
                                            class: _normalizeClass($setup.gameUrl || ($setup.showMessage && !$setup.isMobile)
                                                ? 'tw-mt-6 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4'
                                                : 'tw-grid tw-grid-cols-2 md:tw-grid-cols-5 tw-gap-5 tw-mt-6')
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                    return _createElementVNode("div", {
                                                        key: 'skeleton-' + index,
                                                        class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                    }, _cache[7] || (_cache[7] = [
                                                        _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md tw-h-32 md:tw-h-44 tw-w-full" }, null, -1)
                                                    ]));
                                                }), 64))
                                            ]),
                                            _: 1
                                        }, 8, ["class"]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : _createCommentVNode("", true),
                            ($props.games.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_component_CardContent, {
                                        class: _normalizeClass($setup.gameUrl || ($setup.showMessage && !$setup.isMobile)
                                            ? 'scroller tw-grid tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-4'
                                            : 'scroller tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-5 tw-gap-4')
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.games, (game) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: game.id
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "tw-flex tw-relative tw-items-center tw-gap-4 2xl:tw-gap-3 tw-rounded tw-cursor-pointer tw-w-full tw-h-full",
                                                        onClick: ($event) => ($setup.handleGameClick(game))
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: game.gameIcon
                                                                ? game.gameIcon
                                                                : 'https://contents.static-slotcity.com/game_pic/bng/197.png',
                                                            alt: game.name,
                                                            class: "tw-object-cover tw-rounded-xl tw-w-full tw-h-full"
                                                        }, null, 8, _hoisted_14),
                                                        _createElementVNode("div", _hoisted_15, [
                                                            _cache[8] || (_cache[8] = _createElementVNode("button", { class: "play-btn-game tw-mb-2" }, "Play", -1)),
                                                            _createElementVNode("h2", _hoisted_16, _toDisplayString(game?.name), 1),
                                                            _createElementVNode("p", _hoisted_17, _toDisplayString($props.selectedLiveCategory?.name), 1)
                                                        ])
                                                    ], 8, _hoisted_13)
                                                ]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["class"]),
                                    ($props.isLoading)
                                        ? (_openBlock(), _createBlock(_component_CardContent, {
                                            key: 0,
                                            class: _normalizeClass($setup.gameUrl || ($setup.showMessage && !$setup.isMobile)
                                                ? 'tw-mt-6 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4'
                                                : 'tw-grid tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-5 tw-mt-6')
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                    return _createElementVNode("div", {
                                                        key: 'skeleton-' + index,
                                                        class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                    }, _cache[9] || (_cache[9] = [
                                                        _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md md:tw-h-32 tw-h-[70px] tw-w-full" }, null, -1)
                                                    ]));
                                                }), 64))
                                            ]),
                                            _: 1
                                        }, 8, ["class"]))
                                        : _createCommentVNode("", true)
                                ], 512))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ], 2)
            ], 2)
        ])
    ]));
}
